import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ProgressPageComponent } from './progress-page/progress-page.component';
import { EmailPageComponent } from './email-page/email-page.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { SuccessComponent } from './success/success.component';
import { TarificationComponent } from './tarification/tarification.component';
import { MentionsLegalesComponent } from './mentions-legales/mentions-legales.component';
import { PolitiqueDeConfidentialiteComponent } from './politique-de-confidentialite/politique-de-confidentialite.component';
import { ConditionsGeneralesVentesComponent } from './conditions-generales-ventes/conditions-generales-ventes.component';
import { ContactComponent } from './contact/contact.component';
import { LoginComponent } from './login/login.component';
import { EspaceClientComponent } from './espace-client/espace-client.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { RemoveComponent } from './remove/remove.component';
import { RemoveDataComponent } from './remove-data/remove-data.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'progress-page', component: ProgressPageComponent },
  { path: 'email-page', component: EmailPageComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'success', component: SuccessComponent },
  { path: 'tarification', component: TarificationComponent },
  { path: 'mentions-legales', component: MentionsLegalesComponent },
  { path: 'politique-de-confidentialite', component: PolitiqueDeConfidentialiteComponent },
  { path: 'conditions-generales-ventes', component: ConditionsGeneralesVentesComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'login', component: LoginComponent },
  { path: 'espace-client', component: EspaceClientComponent },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  { path: 'supprimer-mes-donnees-personnelles', component: RemoveComponent },
  { path: 'suppression-de-donnees', component: RemoveDataComponent }
];
